// import React from 'react';
// import './App.css';
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Login from './component/Login';
// import Register from './component/Register';
// import Home from './component/Home';
// import MovieDetails from './component/MovieDetails';
// import Watch from './component/Watch';
// import Watchlist from './component/Watchlist';
// import Profile from './component/Profile';
// import MovieCategories from './component/MovieCategories';
// import CategoryMovies from './component/CategoryMovies';
// import MovieRow from './component/MovieRow';
// import AdminNavbar from './component/AdminNavbar';
// import AdminMovies from './component/AdminMovies';
// import AddMovie from './component/AddMovie';
// import EditMovie from './component/EditMovie';
// import AdminDashboard from './component/AdminDashboard';
// import AdminUsers from './component/AdminUsers';
// import AdminReviews from './component/AdminReviews';
// import AdminAnalytics from './component/AdminAnalytics';
// import AdminSettings from './component/AdminSettings';

// function App() {
//   return (
//      <Router>
//       <Routes>
//         {/* Route for Login */}
//         <Route path="/" element={<Login />} />
        
//         {/* Route for Register */}
//         <Route path="/register" element={<Register />} />

//         <Route path="/home" element={<Home />} />
//          <Route path="/movie/:id" element={<MovieDetails />} /> {/* 👈 */}
//          <Route path="/watch" element={<Watch />} />
//          <Route path="/watchlist" element={<Watchlist />} />
//          <Route path="/profile" element={<Profile />} />
//          <Route path="/movie-categories" element={<MovieCategories />} />
//         <Route path="/category/:genre" element={<CategoryMovies />} />
//         <Route path="/movierow" element={<MovieRow />} />
//          <Route path="/adminnavbar" element={<AdminNavbar />} />
//          <Route path="/admin" element={<AdminDashboard />} />
//          <Route path="/adminmovies" element={<AdminMovies />} />
//         <Route path="/add-movie" element={<AddMovie />} />
//        <Route path="/edit-movie/:id" element={<EditMovie />} />
//       <Route path="/adminusers" element={<AdminUsers />} />
//       <Route path="/adminreviews" element={<AdminReviews />} />
//        <Route path="/adminanalytics" element={<AdminAnalytics />} />
//        <Route path="/adminsettings" element={<AdminSettings />} />

         
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";


/* ================= USER SIDE ================= */

const Login = lazy(() => import("./component/Login"));
const Register = lazy(() => import("./component/Register"));
const Home = lazy(() => import("./component/Home"));
const MovieDetails = lazy(() => import("./component/MovieDetails"));
const Watch = lazy(() => import("./component/Watch"));
const Watchlist = lazy(() => import("./component/Watchlist"));
const Profile = lazy(() => import("./component/Profile"));
const MovieCategories = lazy(() => import("./component/MovieCategories"));
const CategoryMovies = lazy(() => import("./component/CategoryMovies"));
const MovieRow = lazy(() => import("./component/MovieRow"));

/* ================= ADMIN SIDE ================= */

const AdminDashboard = lazy(() => import("./component/AdminDashboard"));
const AdminMovies = lazy(() => import("./component/AdminMovies"));
const AddMovie = lazy(() => import("./component/AddMovie"));
const EditMovie = lazy(() => import("./component/EditMovie"));
const AdminUsers = lazy(() => import("./component/AdminUsers"));
const AdminReviews = lazy(() => import("./component/AdminReviews"));
const AdminAnalytics = lazy(() => import("./component/AdminAnalytics"));
const AdminSettings = lazy(() => import("./component/AdminSettings"));
const AdminCategories = lazy(() => import("./component/AdminCategories"));
const AddCategory = lazy(() => import("./component/AddCategory"));
const AdminFeaturedMovies = lazy(() => import("./component/AdminFeaturedMovies"));
const ManageSubscriptions = lazy(() => import("./component/ManageSubscriptions"));
const AddPlan = lazy(() => import("./component/AddPlan"));
const EditPlan = lazy(() => import("./component/EditPlan"));
const SubscriptionChoice = lazy(() => import("./component/SubscriptionChoice"));
const Payment = lazy(() => import("./component/Payment"));

// Loading fallback component
const PageLoader = () => (
  <div className="bg-black vh-100 d-flex flex-column align-items-center justify-content-center text-white">
    <div className="spinner-border text-danger mb-3" style={{ width: "3.5rem", height: "3.5rem" }} role="status"></div>
    <div style={{ fontWeight: 900, fontSize: "2rem" }}>MOVIE<span className="text-danger">FLIX</span></div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("user");
  const token = localStorage.getItem("token");
  
  if (!user || !token) {
    return <Navigate to="/" replace />;
  }
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));
    
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      return <Navigate to="/" replace />;
    }
  } catch (e) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>

          {/* ================= AUTH ROUTES ================= */}

          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* ================= USER ROUTES ================= */}

          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/movie/:id" element={<ProtectedRoute><MovieDetails /></ProtectedRoute>} />
          <Route path="/watch/:id" element={<ProtectedRoute><Watch /></ProtectedRoute>} />
          <Route path="/watchlist" element={<ProtectedRoute><Watchlist /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/select-plan" element={<ProtectedRoute><SubscriptionChoice /></ProtectedRoute>} />
          <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/movie-categories" element={<ProtectedRoute><MovieCategories /></ProtectedRoute>} />
          <Route path="/category/:genre" element={<ProtectedRoute><CategoryMovies /></ProtectedRoute>} />
          <Route path="/movierow" element={<ProtectedRoute><MovieRow /></ProtectedRoute>} />

          {/* ================= ADMIN ROUTES ================= */}

          <Route path="/admin" element={<ProtectedRoute><Navigate to="/admin/dashboard" /></ProtectedRoute>} />

          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/movies" element={<ProtectedRoute><AdminMovies /></ProtectedRoute>} />
          <Route path="/admin/add-movie" element={<ProtectedRoute><AddMovie /></ProtectedRoute>} />
          <Route path="/admin/edit-movie/:id" element={<ProtectedRoute><EditMovie /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviews /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
          <Route path="/admin/add-category" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
          <Route path="/admin/featured-movies" element={<ProtectedRoute><AdminFeaturedMovies /></ProtectedRoute>} />
          <Route path="/admin/subscriptions" element={<ProtectedRoute><ManageSubscriptions /></ProtectedRoute>} />
          <Route path="/admin/add-plan" element={<ProtectedRoute><AddPlan /></ProtectedRoute>} />
          <Route path="/admin/edit-plan/:id" element={<ProtectedRoute><EditPlan /></ProtectedRoute>} />

          {/* ================= 404 ================= */}

          <Route
            path="*"
            element={
              <h2 style={{ textAlign: "center", marginTop: "100px", color: "white" }}>
                404 - Page Not Found
              </h2>
            }
          />

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;